'use client';

import type { ReactNode, RefObject } from 'react';
import React, { createContext, useContext, useRef } from 'react';

import type { UccModalExposedRef } from './modal.types';

const UccModalContext =
  createContext<RefObject<UccModalExposedRef | null> | null>(null);

export function UccModalProvider({ children }: { children: ReactNode }) {
  const ref = useRef<UccModalExposedRef>(null);

  return (
    <UccModalContext.Provider value={ref}>{children}</UccModalContext.Provider>
  );
}

export function useUccModalContext() {
  return useContext(UccModalContext);
}
